import { hasPermission, useSession } from '../hooks/useSession.tsx';
import { AdminUsage } from './usage/AdminUsage.tsx';
import { MemberUsage } from './usage/MemberUsage.tsx';

/**
 * `/usage` — the permission fork and nothing else. `org:usage:read`
 * gets the org-wide analytics dashboard; everyone else gets the
 * self-scoped view.
 *
 * The two screens are separate modules rather than one component with
 * branches because they query different endpoints: keeping the fork at
 * the top means the member branch can never reach the org-wide data,
 * and that guarantee is readable in one screenful. What they DO share
 * — formatters and the common chrome — lives in `pages/usage/` so
 * their numbers cannot drift apart.
 */
export function Usage(): JSX.Element {
  const { user } = useSession();
  return hasPermission(user, 'org:usage:read') ? <AdminUsage /> : <MemberUsage />;
}
